// extracted by mini-css-extract-plugin
var _1 = "DueDatesSection-modulebody__xODBD SettingsFormSectionContent-modulebody__Hug4g";
export { _1 as "body" }
